// +----------------------------------------------------------------------
// | 重置密码：从邮件链接进来（/reset?token=xxx）
// |
// | 令牌只进邮件、不进接口，所以这里唯一的凭据就是 URL 上的 token。
// | 三种失败（不存在 / 已用过 / 已过期）后端合并成同一句提示 ——
// | 前端照原话展示即可，不要自己拆开判断。
// +----------------------------------------------------------------------
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../../api/auth';
import '../../css/auth.less';

export default function Reset() {
  const [params] = useSearchParams();
  const token = (params.get('token') || '').trim();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [okUser, setOkUser] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (password.length < 6) {
      setError('密码至少 6 位');
      return;
    }
    if (password !== confirm) {
      setError('两次输入的密码不一致');
      return;
    }

    setError('');
    setLoading(true);
    try {
      const data = await resetPassword(token, password);
      setOkUser((data && data.username) || '');
    } catch (err) {
      setError(err.message || '重置失败，链接可能已经过期了');
    } finally {
      setLoading(false);
    }
  };

  // ---------- 链接里没有 token：多半是被截断了 ----------
  if (token === '') {
    return (
      <div className="auth">
        <div className="auth-panel">
          <div className="auth-brand">
            <span className="auth-brand-name">想想</span>
            <span className="auth-brand-sub">重置密码</span>
          </div>

          <div className="auth-card">
            <div className="auth-done">
              <div className="auth-done-icon">🔗</div>
              <h2 className="auth-done-title">这个链接不完整</h2>
              <p className="auth-done-desc">
                链接可能在复制时被截断了。
                <br />
                回邮箱里点一下按钮再试，或者重新申请一封。
              </p>
            </div>

            <Link to="/forgot" className="btn btn-primary btn-block" style={{ textAlign: 'center' }}>
              重新申请重置链接
            </Link>
          </div>

          <Link to="/" className="auth-back">
            ← 先随便看看
          </Link>
        </div>
      </div>
    );
  }

  // ---------- 成功 ----------
  if (okUser !== '') {
    return (
      <div className="auth">
        <div className="auth-panel">
          <div className="auth-brand">
            <span className="auth-brand-name">想想</span>
            <span className="auth-brand-sub">重置密码</span>
          </div>

          <div className="auth-card">
            <div className="auth-done">
              <div className="auth-done-icon">✅</div>
              <h2 className="auth-done-title">密码改好了</h2>
              <p className="auth-done-desc">
                <strong>{okUser}</strong> 的密码已经换成新的了。
                <br />
                <br />
                为了安全，原来登录的设备都退出了，用新密码重新登录就行。
              </p>
            </div>

            <Link to="/login" className="btn btn-primary btn-block" style={{ textAlign: 'center' }}>
              去登录
            </Link>
          </div>

          <Link to="/" className="auth-back">
            ← 先随便看看
          </Link>
        </div>
      </div>
    );
  }

  // ---------- 设新密码 ----------
  return (
    <div className="auth">
      <div className="auth-panel">
        <div className="auth-brand">
          <span className="auth-brand-name">想想</span>
          <span className="auth-brand-sub">设置新密码</span>
        </div>

        <form className="auth-card" onSubmit={handleSubmit}>
          <h2 className="title-lg">设个新密码</h2>
          <p className="muted" style={{ margin: '6px 0 20px' }}>
            设完就能用新密码登录了。
          </p>

          {error && <div className="auth-error">{error}</div>}

          <div className="field">
            <label htmlFor="password">新密码</label>
            <input
              id="password"
              className="input"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="至少 6 位"
            />
          </div>

          <div className="field">
            <label htmlFor="confirm">确认新密码</label>
            <input
              id="confirm"
              className="input"
              type="password"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="再输一次"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block auth-submit" disabled={loading}>
            {loading ? '提交中…' : '确定改密码'}
          </button>

          <div className="auth-switch">
            <Link to="/forgot">链接用不了？重新申请一封</Link>
          </div>
        </form>

        <Link to="/login" className="auth-back">
          ← 回去登录
        </Link>
      </div>
    </div>
  );
}
